export default __webpack_public_path__ + "static/media/designations_ic.a89ba525.svg";